
        import { launchGame } from './scripts/genesys/dev/launcher.js';
        launchGame();
    